import React, { Component } from 'react';
import Api from './Api';
import smoothScroll from 'smoothscroll';
import PlayerList from './PlayerList';
import _ from 'lodash';
const { $, NProgress } = window;


export default class TabFb extends Component {

	constructor(props) {
		super(props);

		if (props.location && props.location.query && props.location.query.id) {
			
		}

     	this.state = { 
     		items : [],
     		page : 0,
            isSearching: false
     	}
        this.loadData = this.loadData.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onLoadMore = this.onLoadMore.bind(this);
        this.onChange = this.onChange.bind(this);

        
    }
    componentDidMount() {
    	//console.log('componentDidMount');
        this.loadData();       

        setTimeout(function() {
        	window.FB.Canvas.setAutoGrow();
            window.FB.Canvas.setSize({height: 2800});
        }, 1000);


    }
    componentWillMount() {
        this.handleSearchDebounced = _.debounce(function (query) {
            // console.log('Debounce');
            this.setState({                
                page: 0,
                query : query,
                errors: {},
                isSearching: true,
            }, () => {   
                this.loadData();
                var searchBox = document.querySelector('.navbar-form');
                smoothScroll(searchBox);
            });
           
        }, 500);
    }


	loadData() {

        NProgress.start();
        let data = 'limit='+ this.state.page +'&' + this.state.query;
       
        Api.post('ajax-get.php', data).then((res) => {
            NProgress.done();
           
            res = res.data;
            if (res.result === 1) {

                let newObject = res.items;
                let itemsResult = this.state.items.concat(newObject);
                if (this.state.isSearching === true){ // no tener que vaciar this.state.items antes de cada busqueda
                    itemsResult = res.items;
                } 

                this.setState({
                    errors: '',
                    items: itemsResult,
                    nextPage: res.next_page,
                    isSearching: false
                });

            } else {            
               
                this.setState({     
                    items : [],                          
                    errors: res.msg,
                    nextPage: false,
                    isSearching: false
                });
              
            }

            setTimeout(function() {
            	window.FB.Canvas.setAutoGrow();
            }, 1000);
            	
        });

        //event.preventDefault();
    }



    onChange(event) {    	
        const query = $(event.target).serialize();        
        this.handleSearchDebounced(query);
    }

    onLoadMore() {     	
    	this.setState({
            page: (this.state.page + 1),                
        }, () => {
        	this.loadData();
        });   	
    }

    onSubmit(event) {
        event.persist();
        event.preventDefault();

        const data = $(event.target).serialize();

    	this.setState({    		
            page: 0,
            query : data,
            errors: {},
            isSearching: true,
    	}, () => {   
       		this.loadData();
       		var searchBox = document.querySelector('.navbar-form');
        	smoothScroll(searchBox);
    	});

      	return false;

    }

	render() {

		return (

			<div className="fb_app">
				<div className="fb_content">
					<header> 
						<a href="http://www.landrover.es/vehicles/discovery/bases-aventura-increible.html" target="_blank" className="link_legal">* TÉRMINOS Y CONDICIONES</a>
						<img src="img/aventura-increible.png" alt="Aventura Increible"/>
					</header>
					<main>
						<div className="fb_intro">
							<h1>Los niños ya han hecho su parte.  <strong>Ahora te toca a ti.</strong>.</h1>
							<div className="text">				
                            
                                <p>Estamos buscando la <strong>#AventuraIncreíble</strong> para el <strong>Nuevo Discovery</strong>, un reto nuevo y casi imposible al que nunca nos hayamos enfrentado, y hemos pedido a los niños que se lo imaginen.</p>

                                <p><strong>Y ya lo han hecho.</strong></p>

                                <p>Ahora te toca a ti votar qué aventura quieres que hagamos realidad. Construiremos el diseño ganador a tamaño real y durante los días 13 y 14 de mayo, el <strong>Nuevo Discovery</strong> vivirá una aventura diferente. Una <strong>#AventuraIncreíble</strong>.</p>
							</div>
							
							{/*<a href={Api.publicUrl()} target="_blank" className="btn btn-gradientYellow">¡Participa!</a>*/}
						</div>
						<div className="search-box">
							<form className="navbar-form" role="search" onSubmit={this.onSubmit} ref={(el) => this.form = el}>
							  	<div className="input-group">
									<input className="form-control" placeholder="BUSCAR..." name="q" id="q" type="text" value={this.props.filterText}  onChange={this.onChange} />
									<div className="input-group-btn">
										<button className="btn btn-default" type="submit"><i className="glyphicon glyphicon-search"></i></button>
									</div>
							    </div>
								
							</form>
						</div>
						<section className="fb_participants">						
							<div id="results">
								<PlayerList items={this.state.items}/>												
								{ this.state.errors && !this.state.isSearching &&
									<div className="result-error">No hay resultados</div>
								}
							</div>
							{
								this.state.nextPage && !this.state.isSearching &&
								<button id="load-more" className="more-elements" onClick={this.onLoadMore}><i className="fa fa-angle-down" aria-hidden="true"></i><span>CARGAR MÁS</span><i className="fa fa-angle-down" aria-hidden="true"></i></button>
							}
						</section>

					</main>
					<footer></footer>

				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/TabFb.js